import type { CSSProperties, ReactNode } from 'react';
import { Icon } from '../core/Icon';

export type ToastTone = 'success' | 'danger' | 'warning' | 'info';

const icons: Record<ToastTone, string> = {
    success: 'circle-check', danger: 'circle-alert', warning: 'triangle-alert', info: 'info',
};

const colors: Record<ToastTone, string> = {
    success: 'var(--success)', danger: 'var(--danger)', warning: 'var(--warning)', info: 'var(--info)',
};

export interface ToastProps {
    tone?: ToastTone;
    title?: ReactNode;
    description?: ReactNode;
    action?: ReactNode;
    onDismiss?: () => void;
    style?: CSSProperties;
}

export function Toast({ tone = 'success', title, description, action, onDismiss, style }: ToastProps) {
    return (
        <div
            role="status"
            style={{
                display: 'flex', gap: 11, alignItems: 'flex-start', width: 360, maxWidth: '90vw',
                padding: '13px 14px', background: 'var(--surface)', border: '1px solid var(--border)',
                borderRadius: 'var(--radius-lg)', boxShadow: 'var(--shadow-lg)',
                animation: 'vec-toast-in var(--dur-slow) var(--ease-entrance)', ...style,
            }}
        >
            <Icon name={icons[tone] ?? icons.info} size={17} style={{ color: colors[tone] ?? colors.info, marginTop: 1 }} />
            <div style={{ flex: 1, minWidth: 0 }}>
                <p style={{ margin: 0, fontSize: 13.5, fontWeight: 600, color: 'var(--text-primary)' }}>{title}</p>
                {description && <p style={{ margin: '3px 0 0', fontSize: 13, lineHeight: '18px', color: 'var(--text-secondary)' }}>{description}</p>}
                {action && <div style={{ marginTop: 9 }}>{action}</div>}
            </div>
            {onDismiss && (
                <button
                    type="button" onClick={onDismiss}
                    aria-label={typeof title === 'string' ? `Fechar aviso: ${title}` : 'Fechar aviso'}
                    style={{ border: 0, background: 'transparent', cursor: 'pointer', color: 'var(--neutral-500)', padding: 0 }}
                >
                    <Icon name="x" size={15} />
                </button>
            )}
            <style>{'@keyframes vec-toast-in{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}'}</style>
        </div>
    );
}
